module.exports = __webpack_public_path__ + "img/volume.cf90c9ff.png";